module.exports = __webpack_public_path__ + "img/mobileBackArrow.a37eed65.svg";